/**
 * A class to store dimensions for an image
 *
 * @param width - The image width
 * @param height - The image height
 */
export class TsImageDimensions {
  constructor(
    public width: number,
    public height: number,
  ) {}
}
